import { Accordion as NovaAccordion, AccordionProps as NovaAccordionProps } from '@fme-nova/components'
import { AccordionProps as MuiAccordionProps, default as MuiAccordion } from '@mui/material/Accordion'

import { createComponentWrapperWithRef } from '../../theme'

/**
 * To be used in conjunction with AccordionSummary and AccordionDetails
 */
export const Accordion = createComponentWrapperWithRef<MuiAccordionProps | NovaAccordionProps>(
  {
    mui: MuiAccordion,
    nova: NovaAccordion,
  },
  'Accordion',
)
